const LocalDBApi = {
   
    saveMsisdnToLocalStorage: (msisdn) => {
        try {
            localStorage.setItem('phoneNumber', msisdn);
            console.log('phoneNumber ' + msisdn + ' saved to Local Cache');
        } catch (error) {
            console.error('saveMsisdnToLocalStorage:: Error while saving phone number:', error.message);
        }
    },

    
    saveUserTypeToLocalStorage: (userType) => {
        if (typeof userType === 'string') {
            try {
                localStorage.setItem('userType', userType);
                console.log('userType ' + userType + ' saved to Local Cache');
            } catch (error) {
                console.error('saveUserTypeToLocalStorage:: Error while saving User Type:', error.message);
            }
        } else {
            console.error('saveUserTypeToLocalStorage:: Invalid userType. Must be a string.');
        }
    },

   
    getFromLocalStorage: (key) => {
        try {
            const value = localStorage.getItem(key);
            return value ? JSON.parse(value) : null;  
        } catch (error) {
            console.error('getFromLocalStorage:: Error while retrieving data:', error.message);
            return null;
        }
    },

    
    removeFromLocalStorage: (key) => {
        try {
            localStorage.removeItem(key);
            console.log(key + ' removed from Local Cache');
        } catch (error) {
            console.error('removeFromLocalStorage:: Error while removing data:', error.message);
        }
    },

   
    clearLocalStorage: () => {
        try {
            localStorage.clear();
            console.log('All data cleared from Local Cache');
        } catch (error) {
            console.error('clearLocalStorage:: Error while clearing data:', error.message);
        }
    }
};

export default LocalDBApi;
